<template>
  <div class="md-layout" :class="`md-alignment-${verticalAlignment}-center`">
    <label class="md-layout-item md-size-20 md-form-label" :class="{
        'md-required':required !== undefined && required !== false,
        'md-disabled':disabled !== undefined && disabled !== false,
        }" :style="`padding-top: ${paddingTopLayout}px; top:auto`">
      <slot name="label"></slot>
    </label>
    <div class="md-layout-item form-row-wings__inputs">
      <slot></slot>
    </div>
    <div class="md-layout-item md-size-20 md-medium-size-100"></div>
  </div>
</template>

<script>
export default {
  name: "FormRowWings",
  props: {
    disabled: {
      type: Boolean,
      default: undefined
    },
    required: {
      type: Boolean,
      default: undefined
    },
    verticalAlignment: {
      type: String,
      default: 'center'
    },
    paddingTopLayout: {
      type: Number,
      default: 0
    }
  }
}
</script>
